<template>
    <div id="app">
        <!--show my logo-->
        <Logo :size="275"/>
        <!--show my name-->
        <Name :name="'Sxtanna'"/>
        <!--show my top links-->
        <Link/>
        <br>
        <!--show my pinned github repositories-->
        <Pins :count="6"/>
        <Lang/>
    </div>
</template>

<script>
    import Link from './components/link.vue'
    import Logo from './components/logo.vue'
    import Name from './components/name.vue'
    import Pins from './components/pins.vue'
    import Lang from './components/lang.vue'

    export default {
        name: 'App',
        components: {
            Logo,
            Link,
            Name,
            Pins,
            Lang,
        },
    }
</script>

<style>
    body, html {
        background: white;
        overflow-x: hidden;
        width: 100%;
        height:100%;
    }

    #app {
        font-family: "Fira Code Retina", monospace;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        margin-top: 30px;
    }
</style>
